import { createReducer } from '@reduxjs/toolkit';
import { enableUserSubscription, updateSubscriptions } from './actions';
import { userSubscriptionsInitialState } from './state';

export const userSubscriptionsReducer = createReducer(userSubscriptionsInitialState, (builder) => {
  builder.addCase(enableUserSubscription, (state) => {
    state.hasSubscription = true;
  });
  builder.addCase(updateSubscriptions, (state, { payload }) => {
    state.subscriptions = payload;
  });
});
